export function Testimonials() {
  const quotes = [
    {
      body: "Dee is the rare designer who can hold the whole product in their head and still care about the kerning. We shipped the best version of our app three months earlier than planned.",
      name: "Iniobong Eshiet",
      role: "CEO, Halt",
    },
    {
      body: "I've hired a lot of designers. Dee is in a category of one. The work raises the standard for everyone around it, engineers included.",
      name: "Marta Rivas",
      role: "VP Product, Loomwork",
    },
    {
      body: "Calm in the room, sharp on the page. The redesign tested 47% better than control on the first round. We just shipped it.",
      name: "Jonas Ek",
      role: "Founder, Helix",
    },
    {
      body: "Dee taught our team how to review. Six months later we have a design culture, not just designers.",
      name: "Aiyana Cole",
      role: "Head of Design, Substrate",
    },
  ];

  return (
    <section className="quotes" id="testimonials">
      <div className="container">
        <div className="quotes-head">
          <span className="eyebrow" data-reveal><span className="dot"></span>Words from the people</span>
          <h2 className="display quotes-title" data-reveal style={{ "--reveal-delay": "80ms" }}>
            What it's like<br />to work with me.
          </h2>
        </div>
        <div className="quotes-grid">
          {quotes.map((q, i) => (
            <figure key={i} className="quote" data-reveal style={{ "--reveal-delay": `${i * 80}ms` }}>
              <span className="quote-mark">"</span>
              <blockquote className="display quote-body">{q.body}</blockquote>
              <figcaption className="quote-cap">
                <span className="quote-name">{q.name}</span>
                <span className="quote-role">{q.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export function Pricing() {
  return (
    <section className="pricing" id="pricing">
      <div className="container">
        <div className="pricing-head">
          <span className="eyebrow" data-reveal><span className="dot"></span>Engagement · transparent rates</span>
        </div>
      </div>
    </section>
  );
}
